import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Accordion from '@r1-frontend/ui-react/deprecated/Accordion';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const themeForAccordion = {
    border: COLORS.Control,
    background: COLORS.Control,
    color: COLORS.TextWhite,
    colorArrow: COLORS.TextWhite,
    backgroundIcon: 'transparent',
    borderIcon: COLORS.TextWhite,
    radius: BorderRadius.componentRadius,
};

export const Questions = styled.div`
    flex-direction: column;
    margin-bottom: -46px;
`;

export const Inner = styled.div`
    flex-direction: column;
    margin-top: 30px;
`;

export const Title = styled.div`
    width: 100%;
    margin-bottom: 30px;
    ${FONTS.H2};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const QuestionText = styled.div`
    flex-direction: column;

    & li {
        position: relative;
        margin-bottom: 7px;
        padding-left: 15px;
    }

    & li:before {
        content: '';
        position: absolute;
        width: 5px;
        height: 5px;
        top: 9px;
        background-color: #fda609;
        left: 0;
        border-radius: 50%;
    }
`;

export const StyledAccordion = styled(Accordion)`
    margin: 5px 0;
    border-radius: ${BorderRadius.OuterBlockRadius};
`;
